/* OO(2026-10-11) サイズの cm を「その商品の説明の ▼SIZE」から読む（会長）
   ＋「空だから隠す」で消えたまま戻らない枠を出す
   ＋ カートのポイントの欄を分かりやすく

   ★なぜ cm を作り直したか
   **同じ OLD ORDER でも靴の形ごとに表が違う**ため（Turbo GT は 35(23.0)、
   Turbo Lite は 36(23.0) から、Ocai・BBiMP は 35(22.5)）、共通の表では 0.5cm ずれます。
   サイズ交換をお受けしていないので、ずれた cm はそのまま誤注文につながります。
   そこで **その商品の説明の ▼SIZE の表から読み取って出す**形にしました。
   表が無い・読めない商品では cm を出しません（間違った数字を出すより安全）。

   ★置き場所
   shop2.js（16,953字）・shop4.js（36,000字）はコネクタの上限 16,384 文字を超えていて
   直せません。読み込みは layout/theme.liquid の shop6.js のすぐ下です。 */
(function () {
  'use strict';

  /* 「35(22.5cm)」「36（23.0cm）」のような書き方から EU→cm の表を作ります。
     3つ以上そろったときだけ「読めた」とみなします。 */
  function parseTable(text) {
    if (!text) return null;
    var map = {};
    var n = 0;
    var re = /(\d{2})\s*[（(]\s*(\d{2}(?:[.．]\d)?)\s*(?:cm|ｃｍ|CM|Cm)/g;
    var m;
    while ((m = re.exec(text))) {
      var eu = m[1];
      if (map[eu]) continue;
      map[eu] = String(m[2]).replace('．', '.');
      n += 1;
    }
    return n >= 3 ? map : null;
  }

  /* 商品説明の折りたたみ（見出しが「商品説明」または「Description」）の中身 */
  function descBox() {
    var sum = null;
    document.querySelectorAll('summary, .accordion__button').forEach(function (e) {
      if (sum) return;
      var t = (e.textContent || '').trim();
      if (t === '商品説明' || t === 'Description') sum = e;
    });
    if (!sum) return null;
    return sum.closest('details') || sum.parentElement;
  }

  var myTable;          // まだ読んでいない = undefined ／ 読めなかった = null

  function table() {
    if (myTable !== undefined) return myTable;
    var box = descBox();
    if (!box) return undefined;                 // まだ出ていない。次の見回りでやり直す
    myTable = parseTable(box.textContent || '');
    return myTable;
  }

  /* サイズのボタンの cm を、その商品の表に合わせます。 */
  function fixCm() {
    var labels = document.querySelectorAll('.product__variant-picker .product-option__label[data-oo-cm]');
    if (!labels.length) return;
    var map = table();
    if (map === undefined) return;              // 説明がまだ出ていない
    labels.forEach(function (lb) {
      //   売り切れの札に印を付けます。字が薄すぎて読めなかったので、
      //   shop5.css でこの印を使って読める濃さに戻します（2026-10-11 会長「文字が見えない」）
      var inpId = lb.getAttribute('for');
      var inp0 = inpId ? document.getElementById(inpId) : null;
      lb.classList.toggle('oo-soldout', !!(inp0 && inp0.disabled));

      var euEl = lb.querySelector('.oo-size-eu');
      if (!euEl) return;
      var eu = (euEl.textContent || '').trim();
      var cmEl = lb.querySelector('.oo-size-cm');
      var want = (map && map[eu]) ? (map[eu] + 'cm') : null;
      if (!want) {
        if (cmEl && cmEl.parentNode) cmEl.parentNode.removeChild(cmEl);
        return;
      }
      if (!cmEl) {
        cmEl = document.createElement('span');
        cmEl.className = 'oo-size-cm';
        var hidden = lb.querySelector('.visually-hidden');
        if (hidden) lb.insertBefore(cmEl, hidden);
        else lb.appendChild(cmEl);
      }
      if (cmEl.textContent !== want) cmEl.textContent = want;
    });
  }

  /* 下に付いてくるバーの「サイズ 36（23.5cm）」も同じ表に合わせます */
  function fixBar() {
    var el = document.querySelector('.oo-buybar__size');
    if (!el) return;
    var t = el.textContent || '';
    var m = t.match(/サイズ\s*(\d{2})/);
    if (!m) return;
    var map = table();
    if (map === undefined) return;
    var eu = m[1];
    var want = (map && map[eu]) ? ('サイズ ' + eu + '（' + map[eu] + 'cm）') : ('サイズ ' + eu);
    if (t !== want) el.textContent = want;
  }

  /* カートの「45／28.0cm」も、その商品の説明の表から出します。 */
  var cache = {};

  function cartCm() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      if (row.getAttribute('data-oo-cm7')) return;
      if (row.querySelector('.cart-item')) return;        // 入れ子の外側はとばす
      if (!(row.innerText || '').trim()) return;          // まだ中身が入っていない
      var a = row.querySelector('a[href*="/products/"]');
      if (!a) return;
      var href = (a.getAttribute('href') || '').split('?')[0];
      row.setAttribute('data-oo-cm7', '1');

      var put = function (map) {
        if (!map) return;
        var walker = document.createTreeWalker(row, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
          var t = (node.nodeValue || '').trim();
          if (/^\d{2}$/.test(t) && map[t]) {
            node.nodeValue = node.nodeValue.replace(t, t + '／' + map[t] + 'cm');
            return;
          }
        }
      };

      if (cache[href] !== undefined) { put(cache[href]); return; }
      fetch(href + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          cache[href] = parseTable(p.description || '');
          put(cache[href]);
        })
        .catch(function () { cache[href] = null; });
    });
  }

  /* 商品ページ下の見出し「お買いもののご案内」を消す（2026-10-11 会長「無くてもいい」）。
     下の3つの折りたたみ（お取り扱い・発送と送料・返品と交換）はそのまま残します。 */
  function hideGuideHead() {
    document.querySelectorAll('h2, h3, h4, span, p').forEach(function (e) {
      if (e.children.length) return;
      var t = (e.textContent || '').trim();
      if (t === 'お買いもののご案内' || t === 'お買い物のご案内' || t.toUpperCase() === 'SHOPPING GUIDE') {
        e.style.display = 'none';
      }
    });
  }

  /* ---------------------------------------------------------------
     「空だから隠す」で消えたまま戻らない枠を、必ず出す（2026-10-11）

     テーマの shop4.js には「中身が空のおすすめは隠す」という処理があり、
     **商品が入る前に「空」と決めつけて隠し、あとから中身が入っても戻していません**でした。
     カートの「こちらもおすすめ」が丸ごと消えていた原因です。
     shop4.js は 36,000 文字あってコネクタから直せないので、ここで戻します。
     中に商品が3つ以上入っている枠だけを出します。
     引き出し・小さな知らせ・覆いは、わざと隠しているので触りません。
     --------------------------------------------------------------- */
  function unhideFilled() {
    document.querySelectorAll('section[id^="shopify-section"]').forEach(function (e) {
      if (e.style.display !== 'none') return;
      var cls = ((e.className || '') + ' ' + (e.id || '')).toString().toLowerCase();
      if (/drawer|modal|popup|overlay/.test(cls)) return;        // わざと隠しているもの
      if (e.querySelectorAll('a[href*="/products/"]').length < 3) return;
      e.style.removeProperty('display');
    });
  }

  /* レビューが0件の商品でも「レビューを書く」だけは出す（2026-10-11 確認役の指摘） */
  function writeReviewLink() {
    if (!document.body.classList.contains('oo-no-review')) return;
    if (document.querySelector('.oo-review-write')) return;
    var src = document.querySelector('.LeeepReviewWriteLink');
    if (!src) return;
    var box = descBox();
    if (!box || !box.parentNode) return;
    var href = src.getAttribute('href') || '';
    var a = document.createElement('a');
    a.className = 'oo-review-write';
    a.href = href || '#';
    a.textContent = 'この商品のレビューを書く ＞';
    if (!href) {
      a.addEventListener('click', function (ev) { ev.preventDefault(); src.click(); });
    }
    box.insertAdjacentElement('afterend', a);
  }

  /* カートに読み上げ用で残っていた英語を日本語に（2026-10-11 確認役） */
  function fixCartWords() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue || '';
      if (v.indexOf('Quantity') < 0) continue;
      node.nodeValue = v.replace(/Quantity\s*:?/g, '数量');
    }
  }

  /* ---------------------------------------------------------------
     カートのポイントの欄を分かりやすく（2026-10-11 会長）

     ポイントを持っていない方のカートで
       「0 ポイント保有中」＋ 何も書いていない白い四角 ＋ 灰色の押せない「ポイントを使う」
     と並び、壊れているように見えていました。

     ・持っているポイントが 0 のとき … 入力欄とボタンを出さず、
       「ポイントは次回のお買い物から使えます（今回の獲得 ○○ポイント）」の1行だけに
     ・ポイントがある方 … 入力欄に「使うポイント数」と分かる字を入れる

     ★ポイントの欄は**ログインしている方のページにしか出ません**。
       ログインしていないときは、この関数は何もしません。
       （アプリ側＝easyPoints の中身は触らず、見た目だけ整えています）
     --------------------------------------------------------------- */
  function fixPoints() {
    if (location.pathname.indexOf('/cart') !== 0) return;
    var holder = null;
    document.querySelectorAll('span, p, div, h6, h5').forEach(function (e) {
      if (holder || e.children.length) return;
      if (/ポイント保有中/.test(e.textContent || '')) holder = e;
    });
    if (!holder) return;                       // ログインしていない＝欄そのものが無い

    var wrap = holder.parentElement;
    for (var i = 0; i < 3 && wrap; i += 1) {
      if (wrap.querySelector('input')) break;
      wrap = wrap.parentElement;
    }
    if (!wrap || wrap.getAttribute('data-oo-pt')) return;
    wrap.setAttribute('data-oo-pt', '1');

    var m = (holder.textContent || '').match(/([\d,]+)\s*ポイント保有中/);
    var have = m ? parseInt(m[1].replace(/,/g, ''), 10) : 0;
    var input = wrap.querySelector('input');
    var btn = null;
    wrap.querySelectorAll('button, input[type="submit"], a').forEach(function (b) {
      if (!btn && /ポイントを使う/.test(b.textContent || b.value || '')) btn = b;
    });

    if (have > 0) {
      //   ポイントがある方：何を入れる欄か分かるようにする
      if (input) {
        if (!input.getAttribute('placeholder')) input.setAttribute('placeholder', '使うポイント数');
        input.setAttribute('aria-label', '使うポイント数');
        input.classList.add('oo-pt-input');
      }
      if (btn) btn.classList.add('oo-pt-btn');
      return;
    }

    //   ポイントが0の方：入力欄とボタンを出さず、1行だけにする
    if (input) {
      var row = input.parentElement;
      if (row && row !== wrap) row.style.setProperty('display', 'none', 'important');
      else input.style.setProperty('display', 'none', 'important');
    }
    if (btn) btn.style.setProperty('display', 'none', 'important');
    holder.style.setProperty('display', 'none', 'important');

    if (wrap.querySelector('.oo-pt-note')) return;
    var got = (document.body.innerText || '').match(/獲得ポイント[\s\S]{0,24}?([\d,]+)\s*ポイント/);
    var p = document.createElement('p');
    p.className = 'oo-pt-note';
    p.textContent = got
      ? ('ポイントは次回のお買い物から使えます（今回の獲得 ' + got[1] + 'ポイント）')
      : 'ポイントは次回のお買い物から使えます';
    wrap.insertBefore(p, wrap.firstChild);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    fixCm();
    fixBar();
    cartCm();
    hideGuideHead();
    unhideFilled();
    writeReviewLink();
    fixCartWords();
    fixPoints();

    var tries = 0;
    var timer = setInterval(function () {
      fixCm();
      fixBar();
      cartCm();
      hideGuideHead();
      unhideFilled();
      writeReviewLink();
      fixCartWords();
      fixPoints();
      tries += 1;
      if (tries >= 30) clearInterval(timer);
    }, 600);

    //   サイズを選び直すと shop2.js が札を作り直すので、そのたびに入れ直します
    document.addEventListener('change', function () {
      setTimeout(function () { fixCm(); fixBar(); }, 120);
    }, true);
    document.addEventListener('click', function () {
      setTimeout(function () { fixCm(); fixBar(); }, 500);
    }, true);

    //   カートの引き出しは、ページを開いたずっとあとに開くことがあります
    if (window.MutationObserver) {
      var moTimer = null;
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(function () {
          cartCm(); fixCm(); unhideFilled(); fixCartWords(); fixPoints();
        }, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})();